import React from "react";
// import "./GroupItemDetail.scss";
import {Route, useRouteMatch} from "react-router-dom";
import {Tabs, Card, List, Checkbox, Space, Col, Row, Button, ColorPicker, Input } from "antd";
import { getActiveKeyFromPathname, getFromLS, getUniqueId } from "lib/utils/helperMethods";
import { useState } from "react";
import { useEffect } from "react";
import OrgProgrammes from "views/OrgProgrammes/OrgProgrammes";
import OrgProgrammeList from "views/OrgProgrammes/OrgProgrammeList/OrgProgrammeList";
import MrTranslate, { useTranslate } from "lib/MrTranslate/MrTranslate";
import { enabledFeaturesSelector } from "views/Auth/Login/selector";
import { useSelector } from "react-redux";
import AIUsage from "./AIUsage/AIUsage";
import OneRoster from "views/Orgs/OrgItemDetail/OneRoster";
import OrgAuditLogs from "views/OrgAuditLogs/OrgAuditLogs";
import OrgPermissions, { OldPermissionsUI } from "views/OrgProgrammes/OrgPermissions/OrgPermissions";
import { DeleteOutlined } from "@ant-design/icons";


const StandardsBasedGradingScales = (props) => {
  const { org, updateResource } = props
  let orgPreferences = org.preferences || {}
  const [scales, setScales] = useState(orgPreferences.grading_scales || []);
  
  const updateGradingScales = (uuid, key, value) => {
    console.log("StandardsBasedGradingScales updateGradingScales", uuid, key, value);
    if (!value) {
      return;
    }
    let newScales = [...scales]
    const index = newScales.findIndex((item) => uuid === item.uuid);
    const scaleToUpdate = newScales[index];
    if (key === "percentage") {
      value = parseInt(value)
    }
    scaleToUpdate[key] = value
    newScales.splice(index, 1, scaleToUpdate);
    console.log("StandardsBasedGradingScales newScales", newScales);
    setScales(newScales)
  }

  const saveGradingScales = () => {
    // TODO: validate required fields
    orgPreferences.grading_scales = scales
    console.log("StandardsBasedGradingScales updateResource", orgPreferences);
    updateResource({id: org.id, preferences: orgPreferences})
  }
  const addRow = () => {
    let newScale = {
      uuid: getUniqueId(10),
      color: "",
      label: "",
      percentage: 0
    }
    let updatedScales = [...scales, newScale]
    setScales(updatedScales)
  }
  const deleteRow = (uuid) => {
    const newScales = scales.filter((item) => item.uuid !== uuid);
    setScales(newScales);
  }

  let finalRender = []

  let headerRow = <Row span={24} key={"header-row"}>
    <Col span={4}> Color </Col>
    <Col span={6}> Proficiency level </Col>
    <Col span={6} offset={1}> Performace threshold (%) </Col>
    <Col span={6} offset={1}> Remove </Col>
  </Row>
  scales.length > 0 && finalRender.push(headerRow)
  scales.forEach((scale, i) => {
    let row = <Row span={24} key={i}>
      <Col span={4}>
        <ColorPicker defaultValue="black" value={scale.color} onChange={(value, hex) => updateGradingScales(scale.uuid, "color", hex)} /> 
      </Col>
      <Col span={6}> 
        <Input value={scale.label} onChange={(e) => updateGradingScales(scale.uuid, "label", e.target.value)} />
      </Col>
      <Col span={6} offset={1}>
        <Input value={scale.percentage} onChange={(e) => updateGradingScales(scale.uuid, "percentage", e.target.value)} />
      </Col>
      <Col span={6} offset={1}> <DeleteOutlined onClick={() => deleteRow(scale.uuid)} /> </Col>
    </Row>
    finalRender.push(row)
  })

  let addButton = <Button key="add-level-button" onClick={() => addRow()}>Add row</Button>
  finalRender.push(addButton)

  let saveButton = <Button type="primary" key="save-button" onClick={() => saveGradingScales()}>Save</Button>
  finalRender.push(saveButton)


  return <Space direction="vertical" style={{width: "100%", maxWidth: "800px"}}>{finalRender}</Space>
}

const OrgItemDetail = (props) => {
  console.log("itemDetail props", props);
  const {item, history, currentUser, org, ...nestedProps} = props;
  const {path, url} = useRouteMatch();
  const mrIntl = useTranslate()
  const { TabPane } = Tabs;
  const enabledFeatures = useSelector(enabledFeaturesSelector());
  const originalUserRole = getFromLS("originalUserRole")
  const orgProgrammeSwitcher =
    (enabledFeatures.org_programme_switch ||
      process.env.REACT_APP_MODE !== "production") &&
    !currentUser.org.is_mb;
  const [activeKey, setActiveKey] = useState(null)
  useEffect(() => {
    let pathNameArray = window.location.pathname.split("/")
    let programsIndex = pathNameArray.indexOf("programs") 
    let key = getActiveKeyFromPathname(window.location.pathname)
    if(key == "org"){
      // activeKey = "general"
      if(item.org_type === "individual"){
        key = "enable-py"
      }else{
        key = "roles"
      }
    } else if (key === "roles"){
      key = "roles"
    } else if (key === "enable-py"){
      key = "enable-py"
    } else if (key === "audit-logs"){
      key = "audit-logs"
    } else if (key === "ai-usage") {
      key = "ai-usage"
    } else if (key === "standards-based-grading-scales") {
      key = "standards-based-grading-scales"
    } else {
      key = "general"
    }
  
    if (programsIndex > -1) {
      key = pathNameArray[programsIndex]
    }

    setActiveKey(key)
  }, [])

  const handleTabClick = (key, event) => {
    console.log('inside orgitemdetail==>', key, url);
    history.push(`${url}/${key}`)
    setActiveKey(key)
  }


  return (
    <React.Fragment>
      {/* <span>{item.section_segment_attributes.title} - {item.segment_type}</span> */}
      {/* <span>Org show - {JSON.stringify(item)}</span> */}
      <Tabs activeKey={activeKey} onTabClick={handleTabClick}>
        {currentUser.role == "superadmin" && (
          <TabPane tab= {mrIntl("OrgItemDetail.general_tab")} key="general">
            {/* <h2>General</h2> */}
            <Card>
              <img
                src={item.attachments_json.logo}
                style={{ "max-height": "70px", marginBottom: "20px" }}
                alt="School logo"
              />
              <div>
                {props.renderForm({
                  name: "orgs-general",
                  config: { isModal: false, visible: true },
                  resource: item, //use this for edit
                })}
              </div>
            </Card>
          </TabPane>
        )}
        {currentUser.role == "superadmin" && (
          <TabPane tab={mrIntl("OrgItemDetail.bulk_import_tab")} key="bulk-import">
            {/* <h2>General</h2> */}
            <Card>
              <div>
                {props.renderForm({
                  name: "orgs-bulk-import",
                  config: { isModal: false, visible: true },
                  resource: item, //use this for edit
                })}
              </div>
            </Card>
          </TabPane>
        )}
        {currentUser.role == "superadmin" && item.is_one_roster && (
          <TabPane tab={"Oneroster Import"} key="oneroster-import">
            <Card>
              <OneRoster orgId={org.id} orgUUID={org.uuid}/>
            </Card>
          </TabPane>
        )}
        {orgProgrammeSwitcher && (
          <TabPane
          //  tab="Enable programs"
          tab= {mrIntl("OrgItemDetail.enable_programs")}
           key="enable-py">
            <Card>
              <div>
                {props.renderForm({
                  name: "orgs-programs-years",
                  config: { isModal: false, visible: true },
                  resource: item, //use this for edit
                })}
              </div>
            </Card>
          </TabPane>
        )}
        {/* { currentUser.permission.manage_permissions.list && */}
        {((currentUser.role === "superadmin") || 
          (currentUser.role === "admin" && currentUser.permission && 
            currentUser.permission.manage_permissions && 
            currentUser.permission.manage_permissions.list)) &&
          <TabPane tab= {mrIntl("OrgItemDetail.permissions")} key="roles">
            <Card>
              {/* TEMP  until org-roles form properly done */}
              {/* IMP: hardcoded for teacher permissions right now */}
              <b>General</b>
              <OldPermissionsUI org={item} updateResource={props.updateResource} />
              {(currentUser.role === "superadmin" || (enabledFeatures.manage_user_level_permissions)) &&
                <OrgPermissions org={item} updateResource={props.updateResource} />
              }
              {/* <div>
                {props.renderForm({
                  name: "org-roles",
                  config: { isModal: false, visible: true },
                  resource: item //use this for edit
                })}
              </div> */}
            </Card>
          </TabPane>
        }
        {((currentUser.role === "superadmin" || 
          originalUserRole === "superadmin" || (process.env.REACT_APP_MODE != "production" && process.env.REACT_APP_MODE != "china_production"))) && (
          <TabPane
          tab= {mrIntl("OrgItemDetail.audit_logs")}
           key="audit-logs">
            <OrgAuditLogs org={org}/>
          </TabPane>
        )}
        {(currentUser.role === "superadmin" || (currentUser.role === "admin" && (enabledFeatures.ai_generate_questions_with_prompt || process.env.REACT_APP_MODE === "development"))) && <TabPane tab={mrIntl("OrgItemDetail.ai_assistant_usage")} key="ai-usage">
          <Card>
           <AIUsage orgId={item.id} aiCreditsUSD={item.custom_fields.ai_credits_usd} />
          </Card>
        </TabPane>}
        {currentUser.role == "superadmin" && (
          <TabPane tab="Org Programmes" key="programs">
            <Route
              path={`${path}/programs`}
              render={(routeProps) => (
                <OrgProgrammes
                  params={{ by_org_id: org.id }}
                  createUpdateParams={{ org_id: org.id }}
                  isRoute={false}
                  {...routeProps}
                  config={{
                    routes: { fetch: true },
                    itemDetail: { widget: OrgProgrammeList },
                  }}
                />
              )}
            />
          </TabPane>
        )}
        {/* <TabPane tab="Features" key="features">
          <h2>Features</h2>
        </TabPane>
        <TabPane tab="Integrations" key="integrations">
          <h2>Integrations</h2>
        </TabPane> */}
        {enabledFeatures.set_grading_scales_for_sbg && currentUser.role === "admin" && (
          <TabPane tab={"Standards based grading scales"} key="standards-based-grading-scales">
            <Card>
              <StandardsBasedGradingScales org={org} updateResource={props.updateResource} />
            </Card>
          </TabPane>
        )}
      </Tabs>
    </React.Fragment>
  );
}


OrgItemDetail.defaultProps = {};

OrgItemDetail.propTypes = {};

export default OrgItemDetail;
